import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Filters {
    constructor (wrapperClass) {
        this.$wrapper = $(wrapperClass);
        this.wrapperClass = wrapperClass;
        this.speed = 300;

        this.$filters = this.$wrapper.find(`${this.wrapperClass}__filter`);
        this.$filterHeadings = this.$wrapper.find(`${this.wrapperClass}__filter__heading`);
        this.$filterLists = this.$wrapper.find(`${this.wrapperClass}__filter__list`);
        this.$checkboxes = this.$wrapper.find(`${this.wrapperClass}__filter__list__item__checkbox`);
        this.$reset = this.$wrapper.find(`${this.wrapperClass}__clear`);

        this.addCountToHeadings();
        this.addScrollbars();
        this.checkAllForCheckedItems();

        this.$checkboxes.on('click', $.proxy(this.checkboxChange, this));
        this.$filterHeadings.on('click', $.proxy(this.headingClick, this));
        this.$reset.on('click', $.proxy(this.resetClick, this));

        $(document).on('keyup', (e) => {
            // Escape Key
            if (e.key === 'Escape') {
                this.closeFilters(this.$filters);
            }
        });

        $(document).on('click', $.proxy(this.documentClick, this));

        $(window).on('resize', debounce(() => {
            this.updateScrollbars();
        }, 300));
    }

    addScrollbars () {
        for (let i = 0; i < this.$filterLists.length; i++) {
            Ps.initialize(this.$filterLists[i]);
        }
    }

    updateScrollbars () {
        for (let i = 0; i < this.$filterLists.length; i++) {
            Ps.update(this.$filterLists[i]);
        }
    }

    addCountToHeadings () {
        this.$filterHeadings.append('<span class="c-filters__filter__heading__count js-filters__filter__heading__count"></span>');
    }

    checkAllForCheckedItems () {
        // Check for active
        for (let i = 0; i < this.$filters.length; i++) {
            const $filter = $(this.$filters[i]);

            this.checkForCheckedItems($filter);
        }
    }

    checkForCheckedItems ($filter) {
        if ($filter.find(':checked').length) {
            $filter.addClass('is-active');
        } else {
            $filter.removeClass('is-active');
        }

        this.updateCountString($filter);
    }

    updateCountString ($filter) {
        let countString = '';

        if ($filter.find(':checked').length) {
            countString = `${$filter.find(':checked').length} selected`;
        }

        $filter.find(`${this.wrapperClass}__filter__heading__count`).text(countString);
    }

    checkboxChange (e) {
        const $elem = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.checkForCheckedItems($filter);
    }

    headingClick (e) {
        const $elem = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.closeFilters(this.$filters.not($filter));

        $filter.toggleClass('is-open').find(`${this.wrapperClass}__filter__list`).slideToggle(this.speed, () => {
            this.updateScrollbars();
        });
    }

    documentClick (e) {
        const $elem = $(e.target);

        if (!$elem.closest(`${this.wrapperClass}__filter__list`).length && !$elem.closest(`${this.wrapperClass}__filter`).length) {
            this.closeFilters(this.$filters);
        }
    }

    closeFilters ($filters) {
        $filters.removeClass('is-open').find(`${this.wrapperClass}__filter__list`).slideUp(this.speed);
    }

    resetForm ($form) {
        $form.find(`${this.wrapperClass}__filter__list__item__checkbox`).prop('checked', false);
        $form.find(`${this.wrapperClass}__hidden-input`).val('');

        this.checkAllForCheckedItems();
    }

    resetClick (e) {
        const $elem = $(e.target);
        const $form = $elem.closest(`${this.wrapperClass}__form`);

        this.resetForm($form);

        $form.submit();
    }
}

export default Filters;
